// extracted by mini-css-extract-plugin
module.exports =  {"option":"option_KGlvks6R","divider":"divider_ChNJOENj"};